import { render } from "./leftBar2.vue?vue&type=template&id=347fbb26"
import script from "./leftBar2.vue?vue&type=script&lang=js"
export * from "./leftBar2.vue?vue&type=script&lang=js"
script.render = render

export default script